module.exports = __webpack_public_path__ + "media/components/assets/sujung_03-c72be294e4ebdcda0bfa6d8a0c5bbdbc.png";